import type { ReactNode } from "react";

interface SectionHeadingProps {
  children: ReactNode;
  align?: "left" | "center";
  className?: string;
  fullUnderline?: boolean;
}

export function SectionHeading({
  children,
  align = "left",
  className = "",
  fullUnderline = false,
}: SectionHeadingProps) {
  const widthClass = fullUnderline
    ? `w-fit${align === "center" ? " mx-auto" : ""}`
    : "";

  return (
    <div
      className={`flex flex-col ${align === "center" ? "items-center text-center" : "items-start"} ${widthClass} ${className}`}
    >
      <h2 className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tight text-white text-balance">
        {children}
      </h2>
      <div
        className={`h-1 ${fullUnderline ? "w-full" : "w-20"} bg-primary rounded-full mt-5`}
      ></div>
    </div>
  );
}
